export default "__VITE_ASSET__CVrb3n6a__"